import { environment } from '@env/environment';

export function getUtcOffsetLabel(
  value: string | null | undefined,
  at: Date = new Date(),
): string | null {
  if (!value) {
    return null;
  }

  return value.includes('/')
    ? offsetLabelFromTimeZoneId(value, at)
    : offsetLabelFromIsoString(value);
}

function offsetLabelFromIsoString(value: string): string | null {
  const match = value.match(/(Z|[+-]\d{2}:?\d{2})$/);
  if (!match) {
    return null;
  }

  if (match[1] === 'Z') {
    return 'UTC+0';
  }

  const offset = match[1];
  const sign = offset[0];
  const hours = parseInt(offset.slice(1, 3), 10);
  const minutes = parseInt(offset.slice(-2), 10);

  return minutes
    ? `UTC${sign}${hours}:${String(minutes).padStart(2, '0')}`
    : `UTC${sign}${hours}`;
}

function offsetLabelFromTimeZoneId(
  timeZoneId: string,
  at: Date,
): string | null {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZoneId,
      timeZoneName: 'shortOffset',
    }).formatToParts(at);
    const tzName = parts.find((part) => part.type === 'timeZoneName')?.value;
    if (!tzName) {
      return null;
    }

    return tzName === 'GMT' ? 'UTC+0' : tzName.replace('GMT', 'UTC');
  } catch {
    return null;
  }
}

/**
 * UTC offset label for service-slot (pickup/delivery window) times.
 * When the brand pins service times to a fixed offset
 * (`environment.serviceTimeZoneOffset`, e.g. Artaah = `'+0300'`) that offset's
 * label is returned; otherwise the label is derived from `source`.
 */
export function getServiceUtcOffsetLabel(
  source: string | null | undefined,
  serviceTimeZoneOffset:
    string | null | undefined = environment.serviceTimeZoneOffset,
): string | null {
  return serviceTimeZoneOffset
    ? getUtcOffsetLabel(serviceTimeZoneOffset)
    : getUtcOffsetLabel(source);
}
